import { useNavigate } from 'react-router-dom';
import {
  Toolbar,
  ToolbarGroup,
  Avatar,
  Button,
  Menu,
  MenuTrigger,
  MenuPopover,
  MenuList,
  MenuItem,
  makeStyles,
  tokens,
} from '@fluentui/react-components';
import {  MoreHorizontal20Regular, Person20Regular, SignOut20Regular, Navigation20Regular, Alert20Regular } from '@fluentui/react-icons';
import { useLayout } from '../../contexts/LayoutContext';
import { useAuth } from '../../hooks/useAuth';

const useStyles = makeStyles({
  toolbar: {
    backgroundColor: tokens.colorNeutralBackground1,
    borderBottom: `1px solid ${tokens.colorNeutralStroke1}`,
    padding: '0 16px',
    height: '56px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1001,
  },
  logo: {
    fontSize: '20px',
    fontWeight: 'bold',
    color: tokens.colorBrandForeground1,
  },
  menuGroup: {
    display: 'flex',
    gap: '8px',
  },
  actions: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  hamburger: {
    cursor: 'pointer',
  },
  desktopToggle: {
    '@media (max-width: 767px)': {
      display: 'none',
    },
  },
});

export default function Navbar() {
  const styles = useStyles();
  const navigate = useNavigate();
  const { sidebarCollapsed, sidebarOpen, setSidebarOpen, setSidebarCollapsed } = useLayout();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const toggleSidebar = () => {
    if (window.innerWidth < 768) {
      setSidebarOpen(!sidebarOpen);
    } else {
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };

  const getLeft = () => {
    if (window.innerWidth < 768) {
      return sidebarOpen ? '240px' : '0px';
    }
    return sidebarCollapsed ? '60px' : '240px';
  };

  return (
    <Toolbar className={styles.toolbar} style={{ left: getLeft() }}>
      <ToolbarGroup>
        <Button icon={<Navigation20Regular />} appearance="subtle" onClick={toggleSidebar} className={styles.hamburger} />        
      </ToolbarGroup>      
      <ToolbarGroup className={styles.actions}>        
        <Button icon={<Alert20Regular />} appearance="subtle" />
        <Menu>
          <MenuTrigger>
            <Button icon={<MoreHorizontal20Regular />} appearance="subtle" />
          </MenuTrigger>
          <MenuPopover>
            <MenuList>
              <MenuItem>Configurações</MenuItem>
              <MenuItem>Ajuda</MenuItem>
            </MenuList>
          </MenuPopover>
        </Menu>
        <Menu>
          <MenuTrigger>
            <Avatar icon={<Person20Regular />} />
          </MenuTrigger>
          <MenuPopover>
            <MenuList>
              <MenuItem icon={<SignOut20Regular />} onClick={handleLogout}>Sair</MenuItem>
            </MenuList>
          </MenuPopover>
        </Menu>
      </ToolbarGroup>
    </Toolbar>
  );
}
